import './self-pickups-alerts.service';
import './self-pickups-api.factory';
import './self-pickups-dialog.service';
import './self-pickups-requests.service';
import './self-pickups-service.service';
